import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  MdEqualizer as MdCharts,
  MdAdd,
  MdAccountCircle as MdUser,
  MdSearch,
  MdTrendingUp,
  MdFileDownload,
  MdAssignment,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp
} from 'react-icons/md';
import { routeConstants, UserProfileSectionType } from 'app/routes/route-constants';
import { AiChatMenuItem } from './ai-chat-menu-item';
import styles from '../mobile-nav.scss';

interface MainMenuItemsProps {
  translation: any;
  aiChatAssistantAccessInfo: any;
  instanceInfo: any;
  onItemClick: () => void;
}

export const MainMenuItems = ({ translation, aiChatAssistantAccessInfo, instanceInfo, onItemClick }: MainMenuItemsProps) => (
  <>
    <li onClick={onItemClick}>
      <Link to={routeConstants.selectCaseType} className="list-group-item">
        <MdAdd className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.new_case}</span>
      </Link>
    </li>

    <li>
      <input type="checkbox" id="mobile-dashboards" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdCharts className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.dashboards}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-dashboards">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li onClick={onItemClick}>
          <Link to={routeConstants.selectDashboard} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.dashboards}</span>
          </Link>
        </li>
        <li onClick={onItemClick}>
          <Link to={routeConstants.selectSavedDashboards} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.saved_dashboards}</span>
          </Link>
        </li>
      </ul>
    </li>

    <AiChatMenuItem
      aiChatAssistantAccessInfo={aiChatAssistantAccessInfo}
      instanceInfo={instanceInfo}
      translation={translation}
      onClick={onItemClick}
    />
    <li onClick={onItemClick}>
      <Link className="list-group-item" to={routeConstants.createFavouriteDraft}>
        <MdSearch id="nav-search-icon" className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.search}</span>
      </Link>
    </li>

    <li onClick={onItemClick}>
      <Link to={routeConstants.userProfileActiveSection(UserProfileSectionType.Settings)} className="list-group-item">
        <MdUser className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.user_profile}</span>
      </Link>
    </li>

    <li onClick={onItemClick}>
      <Link to={routeConstants.myCaseDraftsView} className="list-group-item">
        <MdFileDownload className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.my_case_drafts_title}</span>
      </Link>
    </li>

    <li onClick={onItemClick}>
      <Link to={routeConstants.myDownloadsView} className="list-group-item">
        <MdFileDownload className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.my_downloads_title}</span>
      </Link>
    </li>

    <li>
      <input type="checkbox" id="mobile-reports" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdAssignment className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.reports}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-reports">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li onClick={onItemClick}>
          <Link to={routeConstants.favouriteDraftNew} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.new_report}</span>
          </Link>
        </li>
        <li onClick={onItemClick}>
          <Link to={routeConstants.selectSavedReports} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.reports_saved}</span>
          </Link>
        </li>
        <li onClick={onItemClick}>
          <Link to={routeConstants.selectCompanyReports} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.reports_company}</span>
          </Link>
        </li>
        <li onClick={onItemClick}>
          <Link to={routeConstants.selectSavedCompanyReports} className="list-group-item">
            <MdTrendingUp className={styles.navItemIcon} />
            <span className={styles.navItemText}>{translation.saved_reports_company}</span>
          </Link>
        </li>
      </ul>
    </li>
  </>
);
